import React from 'react'

export const SEARCH_TYPE_OPTIONS = [
  {
    value: 'linkedin',
    label: 'Linkedin URL',
    filter_name: 'social_url',
    placeholder: 'Search by LinkedIn URL',
    input_type: 'url',
  },
  {
    value: 'email_address',
    label: 'Email Address',
    filter_name: 'email_address',
    placeholder: 'Search by Email Address',
    input_type: 'email',
  },
  {
    value: 'name',
    label: 'Name',
    filter_name: 'name',
    placeholder: 'Search by Name',
    input_type: 'text',
  },
]

export const SWITCH_OPTIONS = [
  {
    label: 'Visible',
    value: 'visible',
    fontColor: '#7d7d7d',
    selectedFontColor: '#008000',
  },
  {
    label: 'Hidden',
    value: 'hidden',
    fontColor: '#7d7d7d',
    selectedFontColor: '#ff0000',
  },
]

export const SOCIAL_ICONS = {
  order: ['salesnavigator', 'linkedin'],
  icons: {
    salesnavigator: {
      icon:
        <i
          className="fa fa-compass"
          aria-hidden="true"
          style={{ fontSize: '18px' }}
        >
        </i>
    },
    linkedin: {
      icon:
        <i
          className="fa fa-linkedin-square"
          aria-hidden="true"
          style={{ fontSize: '18px' }}
        >
        </i>
    }
  }
}
